export default "__VITE_ASSET__GyzNaqQx__"